import MuiTableBody, { TableBodyProps as MuiTableBodyProps } from '@mui/material/TableBody';

export type TableBodyProps = MuiTableBodyProps;

export const TableBody = (props: TableBodyProps) => {
  return <MuiTableBody {...props} />;
};
